import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';

export default () => ({ breakpoints }: Theme) =>
  createStyles({
    containerGraph: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'nowrap',
      cursor: 'pointer',
      padding: '8px 8px 0 8px',
      height: '100%',
      [breakpoints.down('md')]: {
        marginLeft: 0,
        justifyContent: 'flex-start',
      },
      [breakpoints.down(775)]: {
        justifyContent: 'center',
      },
      [breakpoints.down(575)]: {
        justifyContent: 'flex-start',
      },
    },

    containerCard: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1,
      width: '100%',
      [breakpoints.down('md')]: {
        flexBasis: '50%',
      },
    },
  });

export const overrideCardGraph = (breakpoints): any => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  [breakpoints.down('md')]: {
    flexFlow: 'column-reverse',
    alignItems: 'baseline',
    justifyContent: 'flex-start',
    height: '100%',
  },
  [breakpoints.down(775)]: {
    flexFlow: 'unset',
    alignItems: 'center',
  },
  [breakpoints.down(575)]: {
    flexFlow: 'column-reverse',
    alignItems: 'baseline',
    justifyContent: 'flex-start',
    height: '100%',
  },
  minHeight: 130,
  '&:after': {
    content: '""',
    position: 'absolute',
    width: 180,
    height: 180,
    borderRadius: '50%',
    zIndex: 1,
    top: -75,
    right: -141,
  },
  '&:before': {
    content: '""',
    position: 'absolute',
    zIndex: 1,
    width: 180,
    height: 180,
    borderRadius: '50%',
    top: -125,
    right: -100,
    opacity: 0.5,
  },
});
